import React, { useContext, useRef, useState } from 'react';
import { getTorneiInEvidenza, iconSportCssClass } from '../data/utils';
import { usePrematchData } from '../prematch/PrematchDataFetcher';
import { getLabel } from '../InitData';
import PrematchContext from '../contexts/PrematchContext';

export default function TopLeagues() {
    const prematchData = usePrematchData();
    const prematchContext = useContext(PrematchContext);
    const [selections, setSelections] = useState({});
    const selectionsIds = Object.keys(selections);
    const selectionsCount = selectionsIds.length;
    
    const highlights = getTorneiInEvidenza(prematchData.sport, 'ALL');
    const tournamentsCount = highlights.tournamentsList.length;
    if (tournamentsCount === 0) {
        return null;
    }

    function toggleAll() {
        setSelections(prev => {
            if (selectionsCount === tournamentsCount) {
                return {};
            } else {
                const newSelections = {};
                highlights.sportsList.forEach(sport =>
                    sport.competitions.forEach(t =>
                        newSelections[t.uniqueId] = true
                    )
                );
                return newSelections;
            }
        });
    }

    return (
        <>
            <div className="section-title" onClick={toggleAll}>
                <input type="checkbox" checked={selectionsCount === tournamentsCount} onChange={toggleAll} />
                <span className="title">{getLabel('menu_prematch.in_evidenza')}</span>
            </div>
            <div className="top-leagues">
                {highlights.sportsList.map(sport => {
                    const icoSport = iconSportCssClass(sport.id, sport.iconClass);
                    
                    return sport.competitions.map(t => {
                        const id = t.uniqueId;

                        function toggle() {
                            setSelections(prev => {
                                if (prev[id] == null) {
                                    prev[id] = true;
                                } else {
                                    delete prev[id];
                                }
                                return {...prev};
                            });
                        }

                        const htmlId = `cb-${id}`;

                        return (

                            <div key={id} className="checkbox-selector">
                                <input type="checkbox" checked={selections[id] != null} onChange={toggle} id={htmlId} />
                                <div className={"icona-sport ico-sport " + icoSport}></div>
                                <div className="checkbox-selector-desc" onClick={() => prematchContext.openTournaments([id])}>{t.descrizione}</div>
                            </div>
                        );
                    })
                })}
            </div>
            {selectionsCount > 0 &&
                <div className="cta-w-btn">
                    <span>{getLabel('menu_prematch.apri_tornei_ev')}:</span>
                    <button className="cta-btn" onClick={() => prematchContext.openTournaments(selectionsIds)}>{getLabel('carrello.fun_bonus.next')}</button>
                </div>
            }
        </>
    );
}
